import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';

const THEME_STORAGE_KEY = 'appTheme';

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const themeLink = document.getElementById('dx-theme-link');
  if (themeLink) {
    themeLink.href = `${process.env.PUBLIC_URL}/themes/${theme === 'dark' ? 'dark' : 'light'}.css`;
  }
}

function ThemeProvider(props) {
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_STORAGE_KEY) || 'dark');

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }} {...props} />
  );
}

const ThemeContext = createContext({});
const useTheme = () => useContext(ThemeContext);

export { ThemeProvider, useTheme };
